import getConfig from 'next/config';
import { DefaultPrivacyLevel } from '@datadog/browser-rum';
import { LoggerFactory } from '@cvent/logging/LoggerFactory';

const { publicRuntimeConfig } = getConfig();

/**
 * Returns the configured sample rate if its is between 0 and 100 otherwise,
 * null is returned.
 */
const convertValidSampleRate = (sampleRate?: string): number | undefined => {
  if (sampleRate) {
    const sampleRateNumber = parseFloat(sampleRate);
    if (sampleRateNumber >= 0 && sampleRateNumber <= 100) {
      return sampleRateNumber;
    }
  }
  return undefined;
};

export const datadogOptions = {
  ...(typeof window !== 'undefined' ? { allowedTracingUrls: [window.location.origin] } : {}),
  applicationId: publicRuntimeConfig.DD_APP_ID,
  clientToken: publicRuntimeConfig.DD_CLIENT_TOKEN,
  service: publicRuntimeConfig.DD_SERVICE,
  env: publicRuntimeConfig.DD_ENV,
  version: publicRuntimeConfig.DD_VERSION,
  sessionSampleRate: convertValidSampleRate(publicRuntimeConfig.DD_SESSION_SAMPLE_RATE) || 100,
  sessionReplaySampleRate: convertValidSampleRate(publicRuntimeConfig.DD_SESSION_REPLAY_SAMPLE_RATE) || 25,
  traceSampleRate: convertValidSampleRate(publicRuntimeConfig.DD_TRACE_SAMPLE_RATE) || 25,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: DefaultPrivacyLevel.MASK_USER_INPUT,
  trackSessionAcrossSubdomains: true,
  useSecureSessionCookie: true,
  useCrossSiteSessionCookie: true
};

if (typeof window !== 'undefined') {
  LoggerFactory.initConfig({
    loggerOptions: {
      level: publicRuntimeConfig.LOG_LEVEL?.toLowerCase() || 'warn'
    },
    ...(process.env.NODE_ENV === 'production'
      ? { datadogOptions }
      : {
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          browserTransport: () => {} // for developement env configure a noop browser transport so that it logs to console instead of trying to send logs to DD
        })
  });
}
